import React from "react";
import { Step } from "./Step";

import start_czerwony from "../../assets/start_czerwony.svg";
import start_szary from "../../assets/start_szary.svg";
import dane_kontaktowe_czerwony from "../../assets/dane_kontaktowe_czerwony.svg";
import dane_kontaktowe_szary from "../../assets/dane_kontaktowe_szary.svg";
import mail_czerwony from "../../assets/mail_czerwony.svg";
import mail_szary from "../../assets/mail_szary.svg";
import formularz_czerwony from "../../assets/formularz_czerwony.svg";
import formularz_szary from "../../assets/formularz_szary.svg";
import weryfikacja_czerwony from "../../assets/weryfikacja_czerwony.svg";
import weryfikacja_szary from "../../assets/weryfikacja_szary.svg";
import telefon_czerwony from "../../assets/telefon_czerwony.svg";
import telefon_szary from "../../assets/telefon_szary.svg";
import dziekujemy_czerwony from "../../assets/dziekujemy_czerwony.svg";
import dziekujemy_szary from "../../assets/dziekujemy_szary.svg";
import zrodla_finansowania_czerwony from "../../assets/zrodla_finansowania_czerwony-01.svg";
import zrodla_finansowania_szary from "../../assets/zrodla_finansowania_szary-01.svg";
import verify_icon_gold from "../../assets/verify_icon_gold.png";
import verify_icon_black from "../../assets/verify_icon_black.png";


interface ICircleSteps {
  step: number;
  isMObywatelDone: boolean;
}

const CircleSteps = (props: ICircleSteps) => {
  const { step, isMObywatelDone } = props;

  return (
    <>
      <Step
        image={start_czerwony}
        doneImage={start_szary}
        active={step === 0}
        done={step > 0 || step < 0}
      >
        Start
      </Step>
      <Step
        image={dane_kontaktowe_czerwony}
        doneImage={dane_kontaktowe_szary}
        active={step === 1}
        done={step > 1 || step < 0}
      >
        Podaj dane kontaktowe
      </Step>
      <Step
        image={mail_czerwony}
        doneImage={mail_szary}
        active={step === 2}
        done={step > 2 || step < 0}
      >
        Potwierdź e-mail
      </Step>
      <Step
        image={formularz_czerwony}
        doneImage={formularz_szary}
        active={step === 3}
        done={step > 3 || step < 0}
      >
        Wypełnij wniosek i dodaj dokumenty
      </Step>
      <Step
        image={verify_icon_gold}
        doneImage={verify_icon_black}
        active={step === 9}
        done={isMObywatelDone || (step !== 9 && step > 4) || step < 0}
      >
        Zautoryzuj tożsamość w mObywatel
      </Step>
      <Step
        image={zrodla_finansowania_czerwony}
        doneImage={zrodla_finansowania_szary}
        active={step === 7 || step === 8}
        done={(step !== 8 && step !== 9 && step > 3 && step !== 7) || step < 0}
      >
        Wypełnij ankietę
      </Step>
      <Step
        image={weryfikacja_czerwony}
        doneImage={weryfikacja_szary}
        active={step === 4}
        done={(step > 4 || step < 0) && (step !== 7) && (step !== 8) && step !== 9}
      >
        Zweryfikuj dane
      </Step>
      <Step
        image={telefon_czerwony}
        doneImage={telefon_szary}
        active={step === 5}
        done={(step > 5 || step < 0) && (step !== 7) && (step !== 8) && step !== 9}
      >
        Potwierdź numer telefonu
      </Step>
      <Step
        image={dziekujemy_czerwony}
        doneImage={dziekujemy_szary}
        active={step === 6}
        done={(step > 6 || step < 0) && (step !== 7) && (step !== 8) && step !== 9}
      >
        Dziękujemy
      </Step>
    </>
  );
};

export { CircleSteps };
